import { useContext } from "react";
import { ServiceContext } from "../ServiceProviderContext";
import { ServiceContextProps } from "@/types/services.types";

export function useServices(): ServiceContextProps {
  const context = useContext(ServiceContext);
  if (!context) {
    throw new Error("useServices must be used within a ServiceProvider");
  }
  return context;
}
